import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MenuItem } from '../definition';
import { mmMenuConstants } from '../menu-constants';
import { MmHttpClient } from '../../http/http-client.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MmMenuApiService {

  constructor(private httpClient: MmHttpClient) {

  }

  getMenuTree() {
    return this.httpClient.get<MenuItem[]>(`${mmMenuConstants.menuApiRoute}/tree`);
  }

  saveMenuTree(items: MenuItem[], options?: {
    successMessage: string | Observable<any>
  }) {
    return this.httpClient.put(`api/menu/saveMenu`, items, options);
  }


  getSystemMenu() {
    return this.httpClient.get<MenuItem[]>(`api/menu/getSystemMenu`);
  }

  move(id: string, direction: string) {
    return this.httpClient.put(`${mmMenuConstants.menuApiRoute}/${id}/move/${direction}`, undefined);
  }
}
